import ConfirmationModal from 'components/Modals/ConfirmationModal';
import React from 'react';
import type { UserRow } from '../UserTable/types/UserTable.types';

interface DeleteUserModalProps {
  user: UserRow | null;
  onConfirm: () => Promise<void>;
  onCancel: () => void;
}

const DeleteUserModal: React.FC<DeleteUserModalProps> = ({ user, onConfirm, onCancel }) => {
  if (!user) return null;

  return (
    <ConfirmationModal
      show={true}
      handleShow={(show?: boolean) => {
        if (!show) onCancel();
      }}
      bodyTxt={`Are you sure you want to remove ${user.name} from the workplace?`}
      cancelBtnTxt="Cancel"
      confirmBtnTxt="Yes"
      confirmHandler={onConfirm}
      cancelHandler={onCancel}
    />
  );
};

export default DeleteUserModal;
